import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import { changeLanguage, SUPPORTED_LANGUAGES } from 'i18n';

const preferredLanguageOrder = ['en', 'de', 'es', 'it', 'pt', 'ru', 'ja', 'cn', 'pl', 'cs', 'el', 'da'];
const menuPortalStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 30000 }),
};

const normalizeLanguageCode = (language) =>
  String(language || '')
    .split('/')
    .pop()
    .replace(/\.json$/i, '')
    .trim()
    .slice(0, 2)
    .toLowerCase();

const getLanguageOptions = (i18n) => {
  const resourceStore = i18n.services && i18n.services.resourceStore && i18n.services.resourceStore.data;
  const configuredResources = i18n.options && i18n.options.resources;
  const resources = resourceStore || configuredResources || {};
  const resourceLanguages = Object.keys(resources);
  const languages = resourceLanguages.length ? resourceLanguages : SUPPORTED_LANGUAGES;
  const uniqueLanguages = [...new Set(languages.map(normalizeLanguageCode).filter(Boolean))];

  return [
    ...preferredLanguageOrder.filter((language) => uniqueLanguages.includes(language)),
    ...uniqueLanguages
      .filter((language) => !preferredLanguageOrder.includes(language))
      .sort((first, second) => first.localeCompare(second)),
  ];
};

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.resolvedLanguage || i18n.language || 'en';
  const options = getLanguageOptions(i18n).map((language) => ({
    label: t('language.self', { lng: language }),
    value: language,
  }));

  return (
    <div className="d-language-switcher">
      <label htmlFor="language-switcher">{t('language.label')}</label>
      <Select
        className="d-language-switcher__select"
        classNamePrefix="d-language-select"
        inputId="language-switcher"
        aria-label={t('language.label')}
        isSearchable={false}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
        menuPosition="fixed"
        options={options}
        styles={menuPortalStyles}
        value={options.find((option) => option.value === selectedLanguage) || options[0]}
        onChange={(option) => {
          if (option) changeLanguage(option.value);
        }}
      />
    </div>
  );
};

export default LanguageSwitcher;
